module.exports = __webpack_public_path__ + "img/logo.d0db068c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo.png
// module id = dLd/
// module chunks = 1